// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';

// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import Loading from 'components/loading/loading';

const CategoryList = lazy(
  () => import('pages/categoryManagement/category/categoryList')
);

const CategoryCreate = lazy(
  () => import('pages/categoryManagement/category/createCategory')
);
const CategoryEdit = lazy(
  () => import('pages/categoryManagement/category/categoryEdit')
);
const CategoryShow = lazy(
  () => import('pages/categoryManagement/category/categoryShow')
);

const CategoryRoute = (
  <Route path={routeName.category}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.CATEGORY_VIEW,
            PrivateRouteConst.SELF_CATEGORY_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <CategoryList />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create"
      element={
        <PrivateRoute name={PrivateRouteConst.CREATE_CATEGORY}>
          <Suspense fallback={<Loading />}>
            <CategoryCreate />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.CATEGORY_EDIT,
            PrivateRouteConst.SELF_CATEGORY_EDIT,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <CategoryEdit />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.CATEGORY_VIEW,
            PrivateRouteConst.SELF_CATEGORY_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <CategoryShow />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default CategoryRoute;
